import ko = require("knockout");
import FormResponseConditionEditor = require("./formResponseConditionEditor");
require("../../css/components/formResponseConditionEditor/formResponseConditionEditor.css");
import ugp = require("./userGroupPicker-register");
import validationOptions = require("../Atlas/JQueryValidationOptions");
import { CrnTermCodePickerRegistration } from "./crnTermCodePicker-register";

export class FormResponseConditionEditorRegistration {
    private static isRegistered: boolean;
    public static register() {
        if (!FormResponseConditionEditorRegistration.isRegistered) {
            console.log("form response condition editor registration in progress");
            ko.components.register("form-response-condition-editor", {
                viewModel: FormResponseConditionEditor.FormResponseConditionEditorViewModel,
                template: require("./formResponseConditionEditor.html")
            });
            ko.components.register("question-trigger-form-response-condition-editor", {
                viewModel: FormResponseConditionEditor.QuestionTriggerFormResponseConditionEditorViewModel,
                template: require("./formResponseConditionEditor.html")
            });
            FormResponseConditionEditorRegistration.isRegistered = true;
        } else {
            console.log("form response condition editor already registered");
        }
        ugp.UserGroupPickerRegistration.register();
        CrnTermCodePickerRegistration.register();
        validationOptions.JQueryValidationOptions.register();
        $.validator.setDefaults({ ignore: ":not([force-validation]):hidden" });
    }
}
